module.exports = __webpack_public_path__ + "static/media/015 color panel.cf93166d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/redbox/015 color panel.png
// module id = 607
// module chunks = 0